import { NgModule } from '@angular/core';
import { MediaViewerComponent } from './components/media-viewer/media-viewer.component';
import { RRSpinnerModule } from '../spinner/spinner.module';
import { RRSharedModule } from '../shared-module/shared.module';
import { RRBootstrapModule } from '../bootstrap/bootstrap.module';
import { InViewDirective } from './directives/in-view.directive';

@NgModule({
  declarations: [MediaViewerComponent, InViewDirective],
  imports: [RRSharedModule, RRBootstrapModule, RRSpinnerModule],
  exports: [MediaViewerComponent, InViewDirective],
})
export class RRMediaViewerModule {}
